import React from "react";
import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../utils/getImageUrl";

export default function CartToast({ product }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-4 p-3">
      <div className="w-14 h-14 rounded-lg overflow-hidden bg-gray-100 border">
        <img
          src={getImageUrl(product.images?.[0])}
          alt={product.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex-1">
        <p className="font-semibold text-gray-800 text-sm">{product.title}</p>
        <p className="text-supernova-600 font-bold text-sm">
          ${product.price?.toLocaleString("es-CO")}
        </p>
      </div>

      <button
        onClick={() => navigate("/cart")}
        className="bg-supernova-500 hover:bg-supernova-600 text-white 
                   text-xs font-semibold px-3 py-2 rounded-lg shadow"
      >
        Ver carrito
      </button>
    </div>
  );
}
